/** @format */

const dialog = () => ({
  mutationObserver: null,

  init() {
    this.mutationObserver = new MutationObserver(
      this.mutationObserverCallback.bind(this)
    );

    this.mutationObserver.observe(this.$root, {
      attributes: true,
      attributeFilter: ['open'],
    });
  },

  destroy() {
    this.mutationObserver?.disconnect();
  },

  open() {
    this.$root.showModal();
  },

  close() {
    this.$root.close();
  },

  mutationObserverCallback() {
    const { documentElement } = document;
    const hasScrollLock = documentElement.classList.contains('scroll-lock');

    if (this.$root.open) {
      if (!hasScrollLock) {
        const scrollbarWidth = `${
          window.innerWidth - documentElement.clientWidth
        }px`;
        documentElement.style.setProperty('--scrollbar-width', scrollbarWidth);
        documentElement.style.setProperty('padding-right', scrollbarWidth);
        documentElement.classList.add('scroll-lock');
      }

      this.videoAutoplay();
    } else {
      if (hasScrollLock) {
        documentElement.style.removeProperty('--scrollbar-width');
        documentElement.style.removeProperty('padding-right');
        documentElement.classList.remove('scroll-lock');
      }

      this.stopVideos();
    }
  },

  videoAutoplay() {
    const video = this.$root.querySelector('.js-dialog-video-autoplay');

    if (video && video.tagName === 'VIDEO') {
      video.play();
    }

    const deferredMedia = this.$root.querySelector('deferred-media');

    if (deferredMedia) {
      deferredMedia.loadContent();
    }
  },

  stopVideos() {
    window.pauseAllMedia();
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('dialog', dialog);
});
